import React, { Component } from 'react';
import Header from '../../Layout/Header'
import './TheMoshiDifference.scss'
import Wave from '../../Components/Wave'

class TheMoshiDifference extends Component {
	render() {
		return (
			<div className="page-moshi-difference">
				<Header
					bg="#0e5f7c"
					seoTitle="The Moshi Difference"
					title={<div>the moshi moshi <b>difference</b></div>}
					image={require('./background.jpg')}
					video={{ mp4: require('./video.mp4'), webm: require('./video.webm')}}
				/>
				<div className="entry-content">
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">
								
								Why we're called Moshi Moshi Marketing?
							</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('./cat.jpg')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Influenced by Japanese folklore, <strong>‘Moshi Moshi’</strong> is used to say "hello" when you talk on the telephone. It is also used when you want  to <strong>get someone's attention.</strong></div>
								<p>Co-founder David Byatt, lived and worked in Japan for 3 years. He was inspired by the Japanese people‘s attention to detail and high quality service.</p>
								<p>The MMM for Moshi Moshi Marketing creates a positive sound that we associate with good experiences and great tasting food and drink. It’s an instinctual response that we’re aiming to recreate in your experiences with us.</p>
							</div>
						</div>
					</div>
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A dedicated, yet virtual approach</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi was founded on the belief that we could <strong>deliver amazing work</strong>. Since 2015 we’ve been busy doing just that for our clients.</div>
								<p>We don’t see ourselves as separate from the varied businesses and organisations we support. We are an important part of their success and as such, we take our role seriously and that’s why we only represent one industry per location. We’re supporting you and we are not going to be helping your competitors.</p>
								<p>We are continually assessing our processes to keep costs low and utilising technology to provide a flexible approach to business. We’re passionately driven to do whatever it takes to get the job done well. Come in to our office or we would love to visit your business; this gives us a unique insight into how you operate and what we might be able to do to help make it better!</p>
							</div>

							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('./random.jpg')} reverse />
							</div>
						</div>
					</div>
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">Passionate masters of our craft</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('./wood.jpg')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline"><strong>Passion is what continually drives us to improve.</strong> We spend long hours pushing the boundaries through experimentation, knowing that our best work is yet to come.</div>
								<p>Whilst the technology we work with is changing at an increasing pace, our commitment to mastering our craft is unwavering. There is an insatiable desire to “not just sit still” believing we’ve made it. Every pixel counts and every bit of data can be used to feed our creative process.</p>
								<p>Every project is a fresh opportunity to re-create the world a little differently and a little better than what it was before. We’re not sitting still churning out the same old same for the sake of making our lives easier. We embrace the challenges as an opportunity to test our abilities and create amazing outcomes in the process.</p>
							</div>
						</div>
					</div>
					<section className="the-team">
						<Wave className={`top over`} />
						<Wave className={`bottom over `} />
						<div className="container-fluid">
							<h2 className="outline text-center">
								<div className="line"></div>
								<div className="title">The moshi team and process</div>
							</h2>
							<div className="row">
								{/* <div className="col-lg-4 person">
									<img src={require('./david.png')} alt="David Byatt" />
									<div className="name">
										<strong>David Byatt, </strong>
										Marketing Director
									</div>
								</div> */}
								<div className="col-lg-4 person">
									<img src={require('./karl.png')} alt="Karl Moyse" />
									<div className="name">
										<strong>Karl Moyse, </strong>
										Creative Director
									</div>
								</div>
								
								<div className="col-lg-4 person">
									<img src={require('./adrian.png')} alt="Adrian Twarog" />
									<div className="name">
										<strong>Adrian Twarog, </strong>
										Technical Director
									</div>
								</div>
{/* 								
								<div className="col-lg-4 person">
									<img src={require('./darren.png')} alt="Darren Lewis" />
									<div className="name">
										<strong>Darren Lewis, </strong>
										Business Development Manager
									</div>
								</div> */}
								<div className="col-lg-4 person">
									<img src={require('./lauren.png')} alt="Lauren Dixon" />
									<div className="name">
										<strong>Lauren Dixon, </strong>
										Public Relations Manager
									</div>
								</div>

								{/* <div className="col-lg-4 person">
									<img src={require('./jodie.png')} alt="Jodie Flynn" />
									<div className="name">
										<strong>Jodie Flynn, </strong>
										Business Development Manager
									</div>
								</div> */}



								{/* <div className="col-lg-4 person">
									<img src={require('./sam.png')} alt="Sam Hawley" />
									<div className="name">
										<strong>Sam Hawley, </strong>
										Developer
									</div>
								</div> */}

								{/* <div className="col-lg-4 person">
									<img src={require('./dee.png')} alt="Dee Mosca" />
									<div className="name">
										<strong>Dee Mosca, </strong>
										Creative Producer
									</div>
								</div> */}






							</div>
							<div className="row creative-process">
								<div className="col-lg-4">
									<div className="tagline">Each member brings a set of <strong>specialised skills</strong> that together cover all aspects of marketing.</div>
								</div>
								<div className="col-lg-4 text-center">
									<img src={require('./creative-process.png')} alt="Adrian Twarog" />
								</div>
								<div className="col-lg-4">
									<p>
									Our campaign philosophy is for continual improvement through a cycle of planning, implementation, measuring and assessment. We don't like making guesses; our recommendations are data driven.  Have our team work for your business.
									</p>
								</div>
							</div>
						</div>
					</section>
					<div className="container text-center">
						<h2 className="outline">
							<div className="line"></div>
							<div className="title">Helping to build a stronger community</div>
						</h2>
						<p className="tagline">
						Supporting local not-for-profit organisations is not only great for the community but for your marketing.
						</p>
						<p>
						 We at Moshi Moshi try to support who we can, but the need for funding relief in the region is greater than ever. Identify an organisation that needs what you sell and come to their aid. Sponsorship doesn’t have to be cash-based; money that a not-for-profit can avoid spending is redirected to assisting those in need. Just remember to ask for the not-for-profit’s logo and vice versa so you can both proudly promote your support as a marketing tool.
						</p>
					</div>

					<div className="container-fluid text-center">
					<div className="tagline large"><strong>Moshi</strong> proudly supports local not-for-profits</div>
						
						
						<div className="row">
							<div className="col-lg-3 col-md-6">
								<div className="support-example">
								<div className="support-circle" style={{ backgroundImage: `url(${require('./bunbury-rsl.jpg')})`}}></div>
									<div className="title">Bunbury RSL</div>
									<div className="url"><a href="https://www.bunburyrsl.org.au/">bunburyrsl.org.au</a></div>
									<div className="desc">Bunbury RSL members are volunteers who have served in uniform from one or more of the armed service branches including reserve forces.  Contact them for membership, advocacy and welfare assistance.</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="support-example">
									<div className="support-circle" style={{ backgroundImage: `url(${require('./south-bunbury-rotary.jpg')})`}}></div>
									<div className="title">South Bunbury Rotary</div>
									<div className="url"><a href="https://www.rotarysouthbunbury.org/">rotarysouthbunbury.org</a></div>
									<div className="desc">South Bunbury Rotary club has fun supporting local and international projects which are meaningful and make an impact. Contact them for more information or be a guest at our weekly dinner.</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="support-example">
									<div className="support-circle" style={{ backgroundImage: `url(${require('./hands-up-4-kids.jpg')})`}}></div>
									<div className="title">Hands Up 4 Kids</div>
									<div className="url"><a href="http://handsup4kids.org.au/">handsup4kids.org.au</a></div>
									<div className="desc">Hands Up 4 Kids brokers partnerships between Primary Schools and the community to make a tangible contribution to improving young student’s reading skills.</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="support-example">
									<div className="support-circle" style={{ backgroundImage: `url(${require('./eaton-boomers.jpg')})`}}></div>
									<div className="title">Eaton Boomers</div>
									<div className="url"><a href="https://www.eatonboomers.com.au/">eatonboomers.com.au</a></div>
									<div className="desc">Proud Team in the South West Football League. The club was originally founded in 1959 as the Boyanup Capel Dardanup Football Club.</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="support-example">
								<div className="support-circle" style={{ backgroundImage: `url(${require('./south-west-science-council.jpg')})`}}></div>
									<div className="title">South West Science Council</div>
									<div className="url"><a href="https://www.swsciencecouncil.org.au/">swsciencecouncil.org.au</a></div>
									<div className="desc">The South West Science Council (SWSC) provides a voice and advocacy for a cross-section of sciences in the South West, with a view to encouraging links between local, statewide and international researchers.</div>
								</div>
							</div>
							
							<div className="col-lg-3 col-md-6">
								<div className="support-example">
									<div className="support-circle" style={{ backgroundImage: `url(${require('./jsi.jpg')})`}}></div>
									<div className="title">Just Start IT</div>
									<div className="url"><a href="http://juststartit.edu.au/">juststartit.edu.au</a></div>
									<div className="desc">Just Start IT is an Inter High School Program that teaches and mentors teams made up of Hackers, Hawkers and Hipsters to create a Technology Start Up.</div>
								</div>
							</div>
							<div className="col-lg-3 col-md-6">
								<div className="support-example">
								<div className="support-circle" style={{ backgroundImage: `url(${require('./bunbury-fishing-club.jpg')})`}}></div>
									<div className="title">Bunbury Fishing Club</div>
									<div className="url"><a href="https://www.bunburyfishingclub.com.au/">bunburyfishingclub.com.au</a></div>
									<div className="desc">Promoting safe fun activities on Bunbury's waters. For both onshore and offshore fishers with monthly competitions all year round.</div>
								</div>
							</div>

							<div className="col-lg-3 col-md-6">
								<div className="support-example">
								<div className="support-circle" style={{ backgroundImage: `url(${require('./mens-health-wa.jpg')})`}}></div>
									<div className="title">Men’s Health and Wellbeing WA</div>
									<div className="url"><a href="https://www.menshealthwa.org.au/">menshealthwa.org.au</a></div>
									<div className="desc">Men’s Health and Wellbeing WA is the peak independent not-for-profit charity organisation dedicated to representing and promoting the health and wellbeing of boys and men in Western Australia.</div>
								</div>
							</div>

							
							
						</div>
					</div>
				</div>
				
				
			</div>
		);
	}
}

export const Circle = ({ title, image, className, reverse }) =>
	<div className={`blog-circle-holder`}>
		<div className={`circle-image ${className} ${reverse ? "right" : "left"}`}>
			<div className="recent-circle" style={{ backgroundImage: `url(${image})`}} />
			<div className="recent-circle-title">
				{title}
			</div>
			</div>
	</div>

export default TheMoshiDifference;


// WEBPACK FOOTER //
// ./src/Pages/TheMoshiDifference/TheMoshiDifference.js